export default __webpack_public_path__ + "assets/BankofAmerica-753ac1fed146c98fe597f9251e57568e.svg";